/* AgriEID redesign: behaviour for the product information tabs (sections/ae-info-tabs.liquid).
   Kept in its own file so it never collides with edits to ae-redesign.js. No dependencies. */
(function () {
  'use strict';
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------- product information tabs ---------------- */
  function initInfoTabs(root) {
    var boxes = $$('[data-ae-itabs]', root);
    if (root && root.matches && root.matches('[data-ae-itabs]')) boxes.push(root);
    boxes.forEach(function (box) {
      if (box.dataset.aeReady) return;
      box.dataset.aeReady = '1';
      var tabs = $$('[role="tab"]', box);
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        var list = tab.parentElement;      // phone: keep the chosen tab in view in the scrolling tab row
        if (list && list.scrollWidth > list.clientWidth) list.scrollLeft = Math.max(0, tab.offsetLeft - list.offsetLeft - 20);
        if (focus) tab.focus();
      }
      box.aeSelect = select;
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
      // a link such as #agrieid-lite opens that tab
      function fromHash(scroll) {
        var key = decodeURIComponent((window.location.hash || '').slice(1));
        if (!key) return;
        var tab = tabs.filter(function (t) { return t.getAttribute('data-key') === key; })[0];
        if (tab) { select(tab); if (scroll) box.scrollIntoView(); }
      }
      fromHash(true);
      window.addEventListener('hashchange', function () { fromHash(true); });
    });
  }
  // theme editor: clicking a tab block in the sidebar opens that tab
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest ? e.target.closest('[data-ae-itabs] [role="tab"]') : null;
    var box = tab ? tab.closest('[data-ae-itabs]') : null;
    if (box && box.aeSelect) box.aeSelect(tab);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initInfoTabs(document); });
  else initInfoTabs(document);
  document.addEventListener('shopify:section:load', function (e) { initInfoTabs(e.target); });
})();
